import React, { Suspense, lazy, useState } from "react";
import { Modal } from "react-bootstrap";

const OpenModal = lazy(() => import("./OpenModal"));
const StatusBookedModal = (props) => {
  const { isOpen, closeModal, myEvents, setMyEvents, data } = props;
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <>
      {/* Confirmation Modal */}
      <Modal
        onHide={() => {
          setShowConfirm(false);
        }}
        size="lg"
        show={showConfirm}
        centered
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header className="align-items-center d-flex">
          <Modal.Title id="example-modal-sizes-title-lg" className="ml-3">
            <span className="ModalTitle">Confirmation</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ fontSize: "18px", textAlign: "center", margin: "30px 0" }}>
            Please ensure that the patient is refunded under your guarantee.
          </div>
          <button 
            className="docg-save-btn mx-auto mb-4"
            onClick={() => {
              setShowConfirm(false);
            }}
          >
            Okay
          </button>
        </Modal.Body>
      </Modal>

      {/* Main Modal */}
      <Modal
        size="lg"
        show={isOpen}
        onHide={closeModal}
        dialogClassName="docg-modal"
        aria-labelledby="example-custom-modal-styling-title"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Suspense fallback={<div>Loading...</div>}>
          <OpenModal
            myEvents={myEvents}
            setMyEvents={setMyEvents}
            data={data}
            closePopup={closeModal}
            setShowConfirm={setShowConfirm}
          />
        </Suspense>
      </Modal>
    </>
  );
};

export default StatusBookedModal;
